import { render } from "./App.vue?vue&type=template&id=3f0dc9c0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3f0dc9c0&lang=css"

import exportComponent from "/media/shared/vue/comicviewer-with-router/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__